import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IAssociation, IAssociationEdit, IAssociationEditReduxProps, ITarget } from '../../types/interfaces';

import AssociationFields from '../vente/bien/VAssociationFields';
import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import { editAssociation } from '../../flux/actions/associationActions';
import { getUsers } from '../../flux/actions/userActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faExternalLinkAlt, faPen, faPlus, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import Association from './Association';

const AssociationEdit = ({
  modal,
  setModal,
  modalData,
  selectedBien,
  editAssociation,
  auth
 }: IAssociationEdit) => {
  const selectOptions = [{value: 1, label: "Professionnel"}, {value: 0, label: "Personnel"}];
  const [idValue, setIdValue] = useState(-1);
  const [selectedFloor, setSelectedFloor] = useState<any>();
  const [selectedDivisionType, setSelectedDivisionType] = useState<any>();
  const [selectedDivisionPercent, setSelectedDivisionPercent] = useState<any>();
  const [etageValue, setEtageValue] = useState<any>('');
  const [typeValue, setTypeValue] = useState<any>('');
  const typeOptions = [{value: "APPARTEMENT", label: "Appartement"}, {value: "MAGASIN", label: "Magasin"}];
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState(0);
  const [superficieValue, setSuperficieValue] = useState(0);
  const [prixpartValue, setPrixpartValue] = useState(0);
  const [partCommentValue, setPartCommentValue] = useState('');
  const [modalChoice, setModalChoice] = useState(false);
  const [associationPartInfoHMM, setAssociationPartInfoHMM] = useState<any>('');
  const [selectedChoice, setSelectedChoice] = useState<any>('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const selectedFloorFlag = useRef(true)
  const selectedDivisionTypeFlag = useRef(true)
  const selectedDivisionPercentFlag = useRef(true)

  const alert = useAlert();

  const handleToggle = () => setModal(!modal)
  const handleToggleChoice = () => setModalChoice(!modalChoice)

  useEffect(() => {
    if (selectedFloorFlag.current) {
      selectedFloorFlag.current = false;
      return;
    }
    setSelectedDivisionType(undefined)
    if(selectedFloor?.activePartitionTypeId)
      setSelectedDivisionType(selectedFloor.activePartitionType || '')
  }, [selectedFloor])

  useEffect(() => {
    if (selectedDivisionTypeFlag.current) {
      selectedDivisionTypeFlag.current = false;
      return;
    }
    setSelectedDivisionPercent(undefined)
  }, [selectedDivisionType])

  useEffect(() => {
    if (selectedDivisionPercentFlag.current) {
      selectedDivisionPercentFlag.current = false;
      return;
    }
    setPrixpartValue(0)
  }, [selectedDivisionPercent])

  // useEffect(() => {
  //   if (selectedDivisionPercentFlag.current) {
  //     selectedDivisionPercentFlag.current = false;
  //     return;
  //   }
  //   if(percentOptions?.length === 1 && !selectedDivisionPercent)
  //     setSelectedDivisionPercent(percentOptions[0].value)
  // }, [percentOptions?.length, selectedDivisionPercent])

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const modalOpenedHandle = () => {
    if(modalData){
      selectedFloorFlag.current = true;
      selectedDivisionTypeFlag.current = true;
      selectedDivisionPercentFlag.current = true;
      setIdValue(modalData["id"]);
      if(selectedBien?.division && modalData.divisionPartId){
        const floor = selectedBien.division.division_floors?.find(e => e.division_parts?.find(t => t.id === modalData.divisionPartId))
        setSelectedFloor(floor || '')
        setSelectedDivisionType(floor.activePartitionType || '')
        setSelectedDivisionPercent({percent: Number(modalData["POURCENTAGE"] || 0)})
      }
      else
        setSelectedFloor({floor: modalData["ETAGE"]})
      // setEtageValue(modalData["ETAGE"] ? {value: Number(modalData["ETAGE"]), label: `${Number(modalData["ETAGE"]) === 0 ? "RDC" : Number(modalData["ETAGE"])} (${100 - (!selectedBien.contrat ? 0 : selectedBien.contrat.associations.reduce((n, t) => {
      //   return t.POURCENTAGE && t.ETAGE == Number(modalData["ETAGE"]) ? n + Number(t.POURCENTAGE) : n
      // }, 0))}% disponible)`} : '');
      setTypeValue(modalData["TYPE"] ? (typeOptions.find(e => e.value === modalData["TYPE"]) || {value: modalData["TYPE"], label: modalData["TYPE"]}) : '');
      setPositionValue(modalData["POSITION"]);
      setPercentValue(modalData["POURCENTAGE"]);
      setSuperficieValue(modalData["SUPERFICIE"]);
      setPrixpartValue(modalData["PRIX_VENTE"]);
      setPartCommentValue(modalData["OBSERVATION"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setEtageValue('');
    setTypeValue('');
    setPositionValue('');
    setPercentValue(0);
    setSuperficieValue(0);
    setPrixpartValue(0);
    setPartCommentValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };
  const observationChangeHandler = (e: ITarget) => setPartCommentValue(e.target.value);

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Part modifiée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if((selectedBien?.division && !selectedFloor?.id) || (!selectedBien?.division && !selectedFloor?.floor && selectedFloor?.floor !== 0)){
      alert.error("Veuillez sélectionner un étage");
      return
    }
    if(!typeValue){
      alert.error("Veuillez sélectionner le type de l'association");
      return
    }
    if((selectedBien?.division && !selectedDivisionPercent) || (!selectedBien?.division && !percentValue)){
      alert.error("Veuillez sélectionner un pourcentage");
      return
    }
    if(!prixpartValue){
      alert.error("Veuillez saisir le prix de vente de l'association");
      return
    }
    if(selectedBien?.division && prixpartValue < (Number(selectedFloor?.totalPrice || 0) * selectedDivisionPercent.percent) / 100){
      alert.error(`Prix de part est inférieur à ${selectedDivisionPercent.percent}% du prix de l'étage (${((Number(selectedFloor?.totalPrice || 0) * selectedDivisionPercent.percent) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)`);
      return
    }
    setDisableSubmit(true);
    editAssociation(idValue, selectedFloor, selectedDivisionType, !selectedBien?.division ? selectedFloor?.floor : selectedFloor?.floor, typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : '', positionValue, !selectedBien?.division ? percentValue : selectedDivisionPercent?.percent, superficieValue, prixpartValue, partCommentValue, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification des Parts</ModalHeader>
        <ModalBody>
          <AssociationFields idValue={idValue} selectedBien={selectedBien} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} selectedDivisionType={selectedDivisionType} setSelectedDivisionType={setSelectedDivisionType} selectedDivisionPercent={selectedDivisionPercent} setSelectedDivisionPercent={setSelectedDivisionPercent} etageValue={etageValue} setEtageValue={setEtageValue} typeValue={typeValue} setTypeValue={setTypeValue} positionValue={positionValue} setPositionValue={setPositionValue} percentValue={percentValue} setPercentValue={setPercentValue} superficieValue={superficieValue} setSuperficieValue={setSuperficieValue} prixpartValue={prixpartValue} setPrixpartValue={setPrixpartValue} commentValue={partCommentValue} setCommentValue={setPartCommentValue} isEdit />
          <Container className="linesConfirmationContainer">
            {/* <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="observation">Observation</Label>
                  <Input id="observation" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} />
                </FormGroup>
              </Col>
            </Row> */}
            {false && <Row>
              <Col xs="12">
                <Label>Changer avec une autre part</Label>
                <div className={`encaissementChooseAsso${selectedChoice ? " encaissementChooseAssoSelected" : ""}`} title={selectedChoice ? `${selectedChoice.POURCENTAGE || "-"}% | ${selectedChoice.ETAGE === "0" ? "RDC" : `Étage ${selectedChoice.ETAGE || "-"}`} | ${selectedChoice.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}` : ""} onClick={() => setModalChoice(true)}>
                  {!selectedChoice ? "Choisir une part de l'association" : `${selectedChoice.POURCENTAGE || "-"}% | ${selectedChoice.ETAGE === "0" ? "RDC" : `Étage ${selectedChoice.ETAGE || "-"}`} | ${selectedChoice.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}`}
                </div>
              </Col>
            </Row>}
            <Row className="justify-content-center">
              <Button
                className="btn btn-success linesConfirmationBtn"
                onClick={editHandle}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalChoice} toggle={handleToggleChoice} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
        <ModalHeader toggle={handleToggleChoice}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Choix de l'association</ModalHeader>
        <ModalBody>
          <Association associations={selectedBien?.contrat?.associations || []} etages={selectedBien?.ETAGE_ASS} associationPartInfo={associationPartInfoHMM} setAssociationPartInfo={setAssociationPartInfoHMM} chooseForEnc={(e) => {
            setSelectedChoice(e);
            setModalChoice(false);
          }} isModal />
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAssociationEditReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editAssociation })(AssociationEdit);
